// Onboarding
export const ONBOARDING_STARTED = 'onboarding.started';
export const ONBOARDING_COMPLETE = 'onboarding.complete';
export const ONBOARDING_FLOW_FINALIZED = 'onboarding.onboarding_flow_finalized';
export const ONBOARDING_STEP_COMPLETE = 'onboarding.step.complete';
export const ONBOARDING_STEP_NO_SUGGESTION = 'onboarding.step.no_suggestions';
export const ONBOARDING_STEP_SKIPPED = 'onboarding.step.skipped';
export const ONBOARDING_DOWNLOAD_RECORDER_SCREEN_VIEWED =
  'onboarding.onboarding_download_recorder_screen_viewed';
export const ONBOARDING_SELECTED_USE_CASE = 'onboarding.selected_use_case';
export const ONBOARDING_USER_WORK_PERSONA_SELECTED =
  'onboarding.user_work_persona_selected';

// Home page state
export const HOME_STATE_EMPTY = 'home.state.empty';
export const HOME_STATE_ALMOST_EMPTY = 'home.state.almost.empty';
export const HOME_STATE_NOT_EMPTY = 'home.state.not.empty';
